import { ArchiveStatus, CostStatus, OcrStatus } from '@/tms/gbox-scans/_models/gbox-scans.model';

export interface ScanAnswerRef {
	id: number;
	idBox: number;
	name: string;
	ocrStatus: OcrStatus;
	costStatus: CostStatus;
	archiveStatus: ArchiveStatus;
	updatedAt: string | null;
	driverLedgerEntryId: number | null;
}

export interface GboxAnswer {
	answerId: number | null;
	ordinal: number | null;
	idQuestion: number | null;
	idQuestionElement: number | null;
	questionText: string | null;
	answer: string | null;
	modifyTime: string | null;
	scan?: ScanAnswerRef | null;
}

export interface GboxResponseRow {
	id: number;
	externalId: number;
	idReport: number;
	idBox: number | null;
	idDriver: number | null;
	idDriver2: number | null;
	driverAppId: string | null;
	driverAppId2: string | null;
	timeStamp: string;
	modifyTime: string;
	answers: GboxAnswer[] | null;
	syncedAt: string;
	rawResponse: string | null;
	created_at: string | null;
	updated_at: string | null;
	created_by: string | null;
	updated_by: string | null;
}

export type ReportSortField = 'id' | 'externalId' | 'timeStamp' | 'modifyTime' | 'idReport';

export const PAYMENT_METHOD_ANSWER_FILTER = 'payment_cash_or_private';

export interface PaymentMethodsResponse {
	data: string[];
}

export interface ReportListFilters {
	from: Date | null;
	to: Date | null;
	reportId: number | null;
	boxId: number | null;
	driverId: number | null;
	driverUuid?: string | null;
	scanId?: number | null;
	sortBy?: ReportSortField | null;
	sortDirection?: 'asc' | 'desc' | null;
	answerFilter?: string | null;
	paymentMethod?: string | null;
}

export interface ReportListMeta {
	total: number;
	page?: number;
	limit?: number;
	lastModifyTime: string | null;
}

export interface ReportListResponse {
	data: GboxResponseRow[];
	meta: ReportListMeta;
}
